.overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(4, 3, 8, 0.78);
  backdrop-filter: blur(6px);
}

.dialog {
  display: flex;
  flex-direction: column;
  width: min(100%, 720px);
  max-height: min(88vh, 900px);
  padding: 28px 28px 24px;
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-lg);
  background: var(--color-bg-elevated);
  box-shadow:
    var(--shadow-glow),
    0 24px 48px rgba(0, 0, 0, 0.45);
}

.title {
  margin: 0 0 12px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
}

.localeNote {
  margin: 0 0 12px;
  font-size: 13px;
  line-height: 1.5;
  color: var(--color-text-dim);
}

.content {
  flex: 1;
  min-height: 0;
  margin-bottom: 20px;
  padding: 16px 18px;
  overflow-y: auto;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: rgba(0, 0, 0, 0.2);
}

.closeBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 22px;
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-gold-bright);
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s ease,
    transform 0.15s ease;
}

.closeBtn:hover {
  background: rgba(200, 161, 102, 0.08);
  transform: translateY(-1px);
}
